(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-fashion-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCustomSlider = (root) => {
      if (!root || root.dataset.cfsInitialized === 'true') return;
      root.dataset.cfsInitialized = 'true';

      const track = root.querySelector('[data-cfs-track]');
      const slides = [...root.querySelectorAll('[data-cfs-slide]')];
      const prev = root.querySelector('[data-cfs-prev]');
      const next = root.querySelector('[data-cfs-next]');
      const dots = [...root.querySelectorAll('[data-cfs-dot]')];

      if (!track || slides.length <= 1) return;

      let current = 0;
      let timer = null;
      let startX = 0;
      let isDragging = false;

      const autoplay = root.dataset.autoplay === 'true';
      const speed = Number(root.dataset.speed) || 4000;

   const goTo = (index, userAction = false) => {
  current = (index + slides.length) % slides.length;

  track.style.transform = `translate3d(-${current * 100}%, 0, 0)`;

  slides.forEach((slide) => {
    slide.classList.remove('is-active');

    const media = slide.querySelector('.cfs__image, .cfs__video');

    if (media) {
      media.style.transition = 'none';
      media.style.transform = 'scale(1)';
    }
  });

  const activeSlide = slides[current];

  if (activeSlide) {
    const media = activeSlide.querySelector('.cfs__image, .cfs__video');

    activeSlide.classList.add('is-active');

    if (media) {
      media.style.transition = 'none';
      media.style.transform = 'scale(1.30)';

      void media.offsetWidth;

      requestAnimationFrame(() => {
        media.style.transition =
          'transform 4s cubic-bezier(0.22, 0.61, 0.36, 1)';

        media.style.transform = 'scale(1)';
      });
    }
  }

  dots.forEach((dot, i) => {
    dot.classList.toggle('is-active', i === current);

    dot.setAttribute(
      'aria-selected',
      i === current ? 'true' : 'false'
    );
  });

  if (userAction) {
    restart();
  }
};

      const start = () => {
        if (!autoplay || document.hidden) return;
        clearInterval(timer);
        timer = setInterval(() => goTo(current + 1), speed);
      };

      const stop = () => {
        clearInterval(timer);
        timer = null;
      };

      const restart = () => {
        stop();
        start();
      };

      prev?.addEventListener('click', () => goTo(current - 1, true));
      next?.addEventListener('click', () => goTo(current + 1, true));

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.cfsDot), true);
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      root.addEventListener('touchstart', (event) => {
        startX = event.touches[0].clientX;
        isDragging = true;
        stop();
      }, { passive: true });

      root.addEventListener('touchend', (event) => {
        if (!isDragging) return;
        const endX = event.changedTouches[0].clientX;
        const distance = endX - startX;

        if (Math.abs(distance) > 45) {
          goTo(distance < 0 ? current + 1 : current - 1, true);
        } else {
          start();
        }

        isDragging = false;
      }, { passive: true });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });

      document.addEventListener('shopify:block:select', (event) => {
        const selectedBlock = event.target.closest('[data-cfs-slide]');
        if (!selectedBlock || !root.contains(selectedBlock)) return;
        goTo(Number(selectedBlock.dataset.index), false);
        stop();
      });

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target === root || event.target.contains?.(root)) {
          stop();
        }
      });
goTo(0, false);
      start();
    };

    const boot = () => {
      document
        .querySelectorAll('.custom-fashion-slider[data-section-id]')
        .forEach(initCustomSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector?.('.custom-fashion-slider[data-section-id]');
      if (root) initCustomSlider(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
